import type { NetworkData } from '@dynamic-labs-sdk/client';
import { createBaseNetworkProvider } from '@dynamic-labs-sdk/client/core';

import type { StarknetNetworkProvider } from '../../StarknetNetworkProvider.types';
import { fetchStarknetBalance } from '../fetchStarknetBalance';

export const createStarknetNetworkProvider = (
  networkData: NetworkData
): StarknetNetworkProvider => ({
  ...createBaseNetworkProvider('STARK', networkData),
  getBalance: async ({ address }) => ({
    balance: await fetchStarknetBalance({
      address,
      networkData,
    }),
  }),
});
